var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.10047,
    height: 31.35408,
    viewBox: "0 0 66.10047 31.35408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d0cfce;}.cls-2{fill:#3f3f3f;}.cls-3{stroke:#000;}.cls-3,.cls-4{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-4{stroke:#ea5a47;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line-supplement"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xx",
    className: "cls-3",
    d: "M11.7,21.85408s14.4-2.1,49.4-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.2,1.05408S35.5,.05408,25.4,6.65408,9.2,18.35408,9.2,18.35408c0,0-1.8,1.8-1.9,3.9-.2,3,6.9,3.9,6.9,3.9l15.4,1.1h35.5s-.2-26.2,0-26.2c.1,0-15.9,0-15.9,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.4,12.45408l3,3H62.1v-7c0-.6-.4-1-1-1h-19s-8.6-.2-18.1,4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.7,21.85408s14.4-2.1,49.4-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.8,
    cy: 28.35408,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.9,
    cy: 28.35408,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1,
    y1: 30.35408,
    x2: 64.1,
    y2: 30.35408
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.2,1.05408S35.5,.05408,25.4,6.65408,9.2,18.35408,9.2,18.35408c0,0-1.8,1.8-1.9,3.9-.2,3,6.9,3.9,6.9,3.9l15.4,1.1h35.5s-.2-26.2,0-26.2c.1,0-15.9,0-15.9,0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "24.4 12.45408 27.4 15.55408 61.1 15.55408"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.1520e59bec406b32afb4a8520a58f0c2.svg";
export { ForwardRef as ReactComponent };